<template>
  <section id="security" class="rk-security">
    <div class="rk-container">
      <div class="rk-section__head">
        <div class="rk-kicker">
          <span class="rk-kicker__rule"></span>
          <span class="rk-kicker__text"><i class="bi bi-shield-check"></i> Security &amp; reliability</span>
        </div>
        <h2>Built so the numbers can be trusted</h2>
        <p>Every account, every login, every record — access is controlled and logged, not left to chance.</p>
      </div>


      <div class="rk-security__grid">
        <div class="rk-security__card" v-reveal="{ delay: 0 }">
          <i class="bi bi-person-badge"></i>
          <h3>Role-based access control</h3>
          <p>Landlords, agents, and caretakers each see only what their role needs — nothing more.</p>
        </div>
        <div class="rk-security__card" v-reveal="{ delay: 120 }">
          <i class="bi bi-clock-history"></i>
          <h3>Audit trails</h3>
          <p>Every payment, edit, and login is logged, so there's always a clear record of what changed and when.</p>
        </div>
        <div class="rk-security__card" v-reveal="{ delay: 240 }">
          <i class="bi bi-lock"></i>
          <h3>Encrypted &amp; backed up</h3>
          <p>Data is encrypted in transit and backed up regularly, so a lost device never means lost records.</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style scoped>
.rk-container { max-width: 1100px; margin: 0 auto; padding: 0 1.5rem; }
.rk-security { padding: 6.5rem 0; background: var(--ink); }

.rk-kicker {
  display: inline-flex; align-items: center; gap: 0.85rem;
  margin-bottom: 1rem;
}
.rk-kicker__rule { width: 32px; height: 3px; background: var(--brass); border-radius: 2px; flex-shrink: 0; }
.rk-kicker__text {
  display: inline-flex; align-items: center; gap: 0.5rem;
  font-family: var(--font-mono); font-size: 0.95rem; font-weight: 700;
  letter-spacing: 0.12em; text-transform: uppercase; color: var(--brass);
}
.rk-kicker__text i { font-size: 1rem; }

.rk-section__head h2 {
  font-family: var(--font-display);
  font-weight: 400;
  font-size: 2.6rem;
  letter-spacing: -0.01em;
  color: var(--paper);
  line-height: 1.15;
}

.rk-section__head p {
  font-family: var(--font-body);
  font-size: 1.05rem;
  color: rgba(247, 246, 242, 0.7);
  line-height: 1.6;
  margin: 0.9rem 0 0;
}

.rk-section__head {
  max-width: 640px;
  margin-bottom: 80px;
}

.rk-security__grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1.75rem; }

.rk-security__card {
  background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08);
  border-radius: var(--radius-lg); padding: 2.25rem;
  transition: all 0.3s var(--ease);
}
.rk-security__card:hover { background: rgba(255,255,255,0.06); transform: translateY(-4px); }
.rk-security__card i { font-size: 1.6rem; color: var(--brass-light); margin-bottom: 1.25rem; display: block; }
.rk-security__card h3 { font-family: var(--font-body); font-weight: 700; font-size: 1.1rem; color: var(--paper); margin: 0 0 0.75rem; }
.rk-security__card p { font-family: var(--font-body); font-size: 0.92rem; color: rgba(247,246,242,0.6); line-height: 1.6; margin: 0; }

@media (max-width: 860px) {
  .rk-security__grid { grid-template-columns: 1fr; }
}
@media (max-width: 560px) {
  .rk-security { padding: 4.5rem 0; }
  .rk-section__head h2 { font-size: 1.85rem; }
}
</style>